"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var constants_1 = require("./constants");
var users_accessible_franchisors_api_1 = __importDefault(require("../api/users_accessible_franchisors_api"));
var config_1 = __importDefault(require("../config"));
var token_service_1 = __importDefault(require("../services/token_service"));
exports.namespaced = true;
exports.state = {
    accessibleFranchisors: {
        franchisors: [],
        franchisorsMap: {},
        isLoading: false,
        error: null
    },
    idToken: token_service_1.default.idToken,
    isForbidden: false
};
exports.actions = {
    getAccessibleFranchisor: function (_a, _b) {
        var commit = _a.commit, getters = _a.getters;
        var franchisorId = _b.franchisorId;
        commit(constants_1.GET_ACCESSIBLE_FRANCHISOR_PENDING, franchisorId);
        var userId = getters.current.id;
        return users_accessible_franchisors_api_1.default
            .get(userId, franchisorId)
            .then(function (data) {
            commit(constants_1.GET_ACCESSIBLE_FRANCHISOR_SUCCESS, data);
            return data;
        })
            .catch(function (error) {
            commit(constants_1.GET_ACCESSIBLE_FRANCHISOR_ERROR, { franchisorId: franchisorId, error: error });
        });
    },
    getAccessibleFranchisors: function (_a) {
        var commit = _a.commit, getters = _a.getters;
        commit(constants_1.GET_ACCESSIBLE_FRANCHISORS_PENDING);
        var userId = getters.current.id;
        return users_accessible_franchisors_api_1.default
            .getAll(userId)
            .then(function (data) {
            commit(constants_1.GET_ACCESSIBLE_FRANCHISORS_SUCCESS, data);
        })
            .catch(function (error) {
            commit(constants_1.GET_ACCESSIBLE_FRANCHISORS_ERROR, error);
        });
    },
    login: function () {
        var returnTo = window.location.href;
        window.location.href = config_1.default.applicationBaseUrl + "/users/sign_in?return_to=" + returnTo;
    },
    logout: function () {
        var returnTo = window.location.href;
        window.location.href = config_1.default.applicationBaseUrl + "/sessions/destroy?return_to=" + returnTo;
    },
    hideForbidden: function (_a) {
        var commit = _a.commit;
        commit(constants_1.HIDE_FORBIDDEN);
    },
    showForbidden: function (_a) {
        var commit = _a.commit;
        commit(constants_1.SHOW_FORBIDDEN);
    }
};
exports.mutations = (_a = {},
    _a[constants_1.GET_ACCESSIBLE_FRANCHISOR_PENDING] = function (state, franchisorId) {
        if (!state.accessibleFranchisors.franchisorsMap[franchisorId]) {
            state.accessibleFranchisors.franchisorsMap[franchisorId] = {};
        }
        state.accessibleFranchisors.franchisorsMap[franchisorId].isLoading = true;
        state.accessibleFranchisors.franchisorsMap[franchisorId].error = null;
    },
    _a[constants_1.GET_ACCESSIBLE_FRANCHISOR_ERROR] = function (state, _a) {
        var franchisorId = _a.franchisorId, error = _a.error;
        state.accessibleFranchisors.franchisorsMap[franchisorId].isLoading = false;
        state.accessibleFranchisors.franchisorsMap[franchisorId].error = error;
    },
    _a[constants_1.GET_ACCESSIBLE_FRANCHISOR_SUCCESS] = function (state, franchisor) {
        state.accessibleFranchisors.franchisorsMap[franchisor.id] = __assign({}, franchisor, { isLoading: false, error: null });
    },
    _a[constants_1.GET_ACCESSIBLE_FRANCHISORS_PENDING] = function (state) {
        state.accessibleFranchisors.isLoading = true;
        state.accessibleFranchisors.error = null;
    },
    _a[constants_1.GET_ACCESSIBLE_FRANCHISORS_ERROR] = function (state, error) {
        state.accessibleFranchisors.isLoading = false;
        state.accessibleFranchisors.error = error;
    },
    _a[constants_1.GET_ACCESSIBLE_FRANCHISORS_SUCCESS] = function (state, franchisors) {
        state.accessibleFranchisors.isLoading = false;
        state.accessibleFranchisors.franchisors = franchisors.map(function (franchisor) { return franchisor.id; });
        state.accessibleFranchisors.franchisorsMap = franchisors.reduce(function (acc, franchisor) {
            var _a;
            return (__assign({}, acc, (_a = {}, _a[franchisor.id] = __assign({}, franchisor, { isLoading: false, error: null }), _a)));
        }, {});
    },
    _a[constants_1.SHOW_FORBIDDEN] = function (state) {
        state.isForbidden = true;
    },
    _a[constants_1.HIDE_FORBIDDEN] = function (state) {
        state.isForbidden = false;
    },
    _a);
exports.getters = {
    accessibleFranchisors: function (state) {
        var franchisors = state.accessibleFranchisors.franchisors.map(function (id) { return state.accessibleFranchisors.franchisorsMap[id]; });
        return franchisors;
    },
    current: function (state) {
        if (state.idToken) {
            return {
                id: state.idToken.sub,
                email: state.idToken.email,
                firstName: state.idToken.first_name,
                lastName: state.idToken.last_name
            };
        }
        else {
            return { id: 0, email: '', firstName: '', lastName: '' };
        }
    },
    isForbidden: function (state) { return state.isForbidden; },
    isLoggedIn: function (state) { return !!state.idToken; }
};
//# sourceMappingURL=user_store.js.map